<!-- 优惠活动 -->
<template>
<div>
    <div :style="{ 'background': 'url(' + require('@/assets/index_bg.png') + ') no-repeat','background-size': '100% 100%'}" class="bg_show">
      <div style="width:90%;margin:0 auto">
      <!-- <van-notice-bar scrollable  text="新版本更新中...." background="transparent" /> -->
    </div>
    <!-- 轮播图 -->
    <div style="width:90%;margin:0 auto">
      <Swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <SwipeItem v-for = '(val,index) in dataImgItem' :key ='index'>
          <van-image width="100%" height="210" radius='10' :src="val.img" />
        </SwipeItem>
      </Swipe>
    </div>
    </div>
     <!-- 一键加油 油卡充值等服务 -->
     <div class="margin">
       <div class="center">
          <van-row type="flex" justify="center">
          <van-col span="6"><van-image width="1rem" height="1rem" :src="require('@/assets/oneKey_home.png')" /><div>一键加油</div></van-col>
          <van-col span="6"><van-image width="1rem" height="1rem" :src="require('@/assets/recharge_home.png')" /><div>油卡充值</div></van-col>
          <van-col span="6"><van-image width="1rem" height="1rem" :src="require('@/assets/integral_home.png')" /><div>积分商城</div></van-col>
          <van-col span="6"><van-image width="1rem" height="1rem" :src="require('@/assets/evaluation_home.png')" /><div>评论服务</div></van-col>
       </van-row>
      </div>
    <!-- 玩转商场 -->
      <van-row style="margin:20px 0px">
        <van-col span="24"><span class="line"></span><span class="txt_blod">玩转广场</span> <span class="txt_bg" style="background:#fe3884">豪礼送不停</span></van-col>
      </van-row>
        <div class="round">
          <van-row type="flex" justify="space-between">
            <van-col @click="dialog" span="8" v-for="(val,key) in goodsGift " :key="key" ><van-image width="48" height="48" :src="val.img" /><div style="font-size:14px;color:#000">{{val.title}}</div><div style="font-size:12px;color:#9893f1">{{val.content}}</div></van-col>
          </van-row>
        </div>
     <!-- 优惠活动 -->
     <van-row style="margin:10px">
        <van-col span="18"><span class="line"></span><span class="txt_blod">优惠活动</span><span class="txt_bg"  style="background:#8c96f7">感恩“价”给你</span></van-col>
         <router-link to="/inte_store">  <van-col span="6"><span class="more">更多<icon name="changyongicon"   class="icon"></icon></span></van-col></router-link>
        </van-row>
      <div style="width:100%;margin-top:10px">
        <div  class="conpon" v-for="(val,key) in conpon" :key="key">
          <div class="con_title"> {{val.title}}</div>
          <div class="con_left">
            <div :style="{ 'background': 'url(' + (val.con_bg) + ') no-repeat','background-size': '100% 100%'}" class="left_icon">
            <div class="text_xxl">
               <span>{{val.money}}</span>
               <span>{{val.full}}</span>
            </div>
            </div>
            <van-row style="  line-height: 30px;margin-left:10px">
              <van-col span="20">满10元可用</van-col>
              <van-col span="20"> <van-tag color="#8c96f7">消费可用</van-tag><span style="font-size:13px;color:#aaa">有效期180天</span></van-col>
              <van-col span="20" style="color:#333;font-size:12px">活动时间为2019-07-01至2019-12-30</van-col>
            </van-row>
          </div>
          <div class="border_left"></div>
          <div  class="border_right"></div>
        </div>
      </div>
      <div>
      <!-- 积分商品 -->
      <van-row style="margin:10px">
        <van-col span="18"><span class="line"></span><span class="txt_blod">积分商品</span><span class="txt_bg"  style="background:#8c96f7">人气爆品</span></van-col>
        <router-link to="/inte_store"><van-col span="6"><span class="more">更多<icon name="changyongicon"   class="icon"></icon></span></van-col></router-link>
      </van-row>
      <!-- 引入底部详情 -->
        <foot-store></foot-store>
     </div>
   </div>
</div>
</template>
<style lang="scss" scoped>
  .bg_show {
    width: 100%;
  }
  .margin {
    width:92%;
    margin:0 auto;
    margin-top:20px;
    }
    .line {
      display: inline-block;
      width:5px;
      height: 20px;
      background:#fe3884;
      margin-bottom: -2px;
      border-radius: 4px;
    }
    .txt_blod {
      font-size:18px;
      font-weight: bold;
      color:#3e3e3e;
      margin-left:5px;
    }

    .txt_bg {
      display: inline-block;
      height: 22px;
      font-size:15px;
      color:#fff;
      border-radius: 4px;
      padding:1px 5px;
      border-bottom-right-radius: 15px;
      margin-left:10px;
    }
    .center {
       box-shadow: 3px 3px 3px #ccc;

      .van-col--6 {
        text-align: center;
        font-size: 13px;
        color: #888;
        line-height: 30px;
      }
    }
    .round {
      margin-top:10px;

      .van-col--8 {
        margin: 5px;
        text-align: center;
        line-height: 25px;
        padding: 5px;
        box-shadow: 3px 3px 3px #ccc;
      }
    }
    .conpon {
      height:150px;
      border: 0.5px solid #ccc;
      border-radius: 5px;
      margin:0 auto;
      position: relative;
      margin-top:20px;

      .con_title {
        width:95%;
        height:auto;
        color:#666;
        font-size:12px;
        border-bottom: 0.5px solid #ccc;
        margin:0 auto;
        line-height:26px
      }

      .con_left {
        width:100%;
        height:90px;
        padding-left:10px;
        margin:0 auto;
        margin-top:5px;
        display: flex;
      }
    }
    .more {
      font-size:14px;
      color: #333;
      float: right;
    }

    .left_icon {
      width: 30%;
      height: 90px;
      text-align: center;

      .text_xxl {
        font-size: 22px;
        color:#fff;
        position: relative;
        top:10px;

        span {
          display: block;
        }
      }
    }
    .border_left {
      width: 6px;
      height: 13px;
      border: 1px solid black;
      background-color: #fff;
      border-radius: 0 100px 100px 0;
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: -1px;
      border: 1px solid #ccc;
      border-left: 0;
    }
    .border_right {
      width: 6px;
      height: 13px;
      border: 1px solid black;
      background-color: #fff;
      border-radius: 100px 0 0 100px;
      position: absolute;
      top: 50%;
      margin-top: -7px;
      right: -1px;
      border: 0.5px solid #ccc;
      border-right: 0;
    }

    .icon {
      width: 20px;
      height: 20px;
      position: relative;
      top:5px;
    }
</style>
<script>
import { Swipe, SwipeItem } from 'vant'
import footStore from '@/components/inte_store/foot_store'
export default {
  name: 'show',
  components: {footStore, Swipe, SwipeItem},
  data () {
    return {
      dataImgItem: [
        {
          img: 'https://maximum_api.bei-lin.cn/wechat_oa/swiper1.png'
        },
        {
          img: 'https://maximum_api.bei-lin.cn/wechat_oa/swiper2.png'
        },
        {
          img: 'https://maximum_api.bei-lin.cn/wechat_oa/swiper3.png'
        }
      ],
      goodsGift: [
        {
          title: '魔力大转盘',
          content: '好运转不停',
          img: require('@/assets/big_b_home.png')

        },
        {
          title: '签到送福利',
          content: '签到领惊喜',
          img: require('@/assets/checkin_home.png')

        },
        {
          title: '分享送好礼',
          content: '好礼送不停',
          img: require('@/assets/shareit_home.png')

        }
      ],
      conpon: [
        {
          title: ' 加油满100元送10元优惠券,下次满50元可用',
          con_bg: require('@/assets/card_no.png'),
          money: 5,
          full: '满减卷'
        },
        {
          title: ' 活动说明：加油满100元送10元优惠券,下次满50元可用',
          con_bg: require('@/assets/card_no2.png'),
          money: 5,
          full: '充值劵'
        }
      ],
      data: []
    }
  },
  methods: {
    dialog () {
      this.$dialog({
        title: '提示!',
        message: '此功能尚未开通',
        confirmButtonText: '关闭'
      }).then(() => {})
    },

    my_mounted () {
      this.get_data()
    },
    // 获取数据
    get_data () {
      this.get_site_data(this, true, (res) => {
        this.data = []
        this.$root.loadingAll = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/discount/show.vue